export function formatCardNumber(value) {
  let digits = value.replace(/\D/g, '');
  return digits.replace(/(\d{4})(?=\d)/g, '$1 ');
}

// export function formatExpiryDate(value) {
//   let cleaned = value.replace(/\D/g, '');
//   if (cleaned.length > 2) {
//     return cleaned.substring(0, 2) + '/' + cleaned.substring(2, 4);
//   }
//   return cleaned;
// }

// export function formatCVV(value) {
//   return value.replace(/\D/g, '').substring(0, 3);
// }
